import * as React from "react";
import * as Immutable from "immutable";
import i18n from "i18n";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import { Alert } from "components/bootstrap";
import LicenseCheck from "../../../license/LicenseCheck";
const getRolesList = (roles, defaultRolesIds) => {
  if (!defaultRolesIds || defaultRolesIds.size === 0) {
    return null;
  }
  const defaultRolesNames = defaultRolesIds.map((roleId) => {
    var _a;
    return (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name;
  });
  return defaultRolesNames.join(", ");
};
const _readableSelectionType = (selectionType) => {
  switch (selectionType) {
    case "all":
      return i18n.t("directory_services.group_sync_details.selection_types.all", { ns: "enterprise_authentication" });
    case "include":
      return i18n.t("directory_services.group_sync_details.selection_types.include", {
        ns: "enterprise_authentication"
      });
    case "exclude":
      return i18n.t("directory_services.group_sync_details.selection_types.exclude", {
        ns: "enterprise_authentication"
      });
    default:
      return selectionType;
  }
};
const GroupSyncDetails = ({ groupSyncBackend, roles, excludedFields = {} }) => {
  const { t } = useTranslation("enterprise_authentication");
  if (!groupSyncBackend) {
    return /* @__PURE__ */ React.createElement(Alert, null, t("directory_services.group_sync_details.not_configured"));
  }
  const {
    defaultRoles,
    selectionType,
    selection = Immutable.Set(),
    config: { groupSearchBase, groupSearchPattern, teamNameAttribute, teamUniqueIdAttribute }
  } = groupSyncBackend;
  const rolesList = defaultRoles && defaultRoles.size >= 1 ? getRolesList(roles, defaultRoles) : null;
  return /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("directory_services.group_sync_details.group_search_base_dn"),
      value: groupSearchBase
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("directory_services.group_sync_details.group_search_pattern"),
      value: groupSearchPattern
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("directory_services.group_sync_details.team_name_attribute"),
      value: teamNameAttribute
    }
  ), !excludedFields.teamUniqueIdAttribute && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("directory_services.group_sync_details.team_id_attribute"),
      value: teamUniqueIdAttribute
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("directory_services.group_sync_details.team_default_roles"), value: rolesList }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("directory_services.group_sync_details.selection_type"),
      value: _readableSelectionType(selectionType)
    }
  ), selectionType !== "all" && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("directory_services.group_sync_details.selected_groups"),
      value: t("directory_services.group_sync_details.selected_groups_count", { size: selection.size })
    }
  ));
};
export default GroupSyncDetails;
